<template>
	<div class="tariff-rate-main">
		<div>
			<Menus :menu="menu" icon="https://dsmlib.logistics.systems/Icons/icons8-expensive-100.png"
				@menuClicked="menuClicked" />
		</div>
		<div class="tariffRateTable">
			<TableBox :tableData="tariffRateList" :selectedRow.sync="selectedArea" title="Tariff Rate" :dataType="columnTypeMain"/>
		</div>
		<PopupEntry :show.sync="popupEntryShow" v-if="popupEntryShow" :title="popupEntryTitle" :createdBy="createdBy"
			:updatedBy="updatedBy" @save="saveClicked" :requiredError="entryRequired" :successMessages="entrySuccess"
			:messages="entryMessages" :errorMessages="entryError" @requiredClicked="entryRequiredClicked" :viewMode="viewMode"
			:cancelButton="viewMode ? 'Close' : 'Cancel'">
			<div class="General Details" style="display : flex; height : 100%;">
				<!-- General Details -->
				<div class="gen-details-right" :style="{ 'width' : (showStatusHistory ? '55%' : '100%')}">
					<!-- error popup for area code -->
					<InputQuery :isDisabled="viewModePK" placeholder="Tariff Area Code" :isRequired="true" ref="tariff_code"
						:items="areaCodeNoTR" itemKey="Area Code" descKey="Tariff Area Code" :selectedObject.sync="selectedAreaCode"
						:errorMessage.sync="tariffCodeError" :allowFreeText="true" :search.sync="newAreaCode"  @selected="tariffArea = $event.Description" @focusChanged="focusChanged"/>
					<Input placeholder="Tariff Area" :inputValue.sync="tariffArea" :errorMessage.sync="tariffAreaError"
						:isRequired="true" ref="tariff_area" :isDisabled=" tariffAreaViewMode" />
					<Input :isDisabled="true" placeholder="Base" :isRequired="true" ref="tariff_base"
						:inputValue.sync="tariffBase" :errorMessage.sync="baseError" />
					<Input :isDisabled="viewMode" placeholder="Tariff Region" style="margin: 0 5px 0 0;"
						:inputValue.sync="tariffRegion" ref="tariff_region" :errorMessage.sync="tariffRegionError" />
					<InputQuery :isDisabled="viewMode" placeholder="Zone Category" ref="zone_category" :items="zoneCategoryData"
						itemKey="Zone Category" descKey="Description" :selectedObject.sync="selectedZoneCategory" :allowFreeText="false" :isRequired="true" :errorMessage.sync="zoneCategoryError" />
					<InputQuery :isDisabled="viewMode" placeholder="Zone Type" ref="zone_type" :items="zoneTypeData"
						itemKey="Zone Type" descKey="Description" :selectedObject.sync="selectedZoneType" :allowFreeText="false" :isRequired="true" :errorMessage.sync="zoneTypeError" />
					<div class="rowBox">
						<Input :isDisabled="viewMode" :isRequired="true" ref="rate_20" placeholder="Rate for Cont. Size 20'"
							style="margin: 0 5px 0 0;" :inputValue.sync="rate_20" :regex="rateRegex" :errorMessage.sync="rate20Error" />

						<Input :isDisabled="viewMode" :isRequired="true" ref="rate_40" placeholder="40'" style="margin: 0 0 0 5px;"
							:inputValue.sync="rate_40" :regex="rateRegex" :errorMessage.sync="rate40Error" />
					</div>
					<div class="rowBox">
						<Input :isDisabled="viewMode" :isRequired="true" ref="comm_20" placeholder="Driver Comm. for Cont 20'"
							style="margin: 0 5px 0 0;" :inputValue.sync="comm_20" :regex="commRegex" :errorMessage.sync="comm20Error" />

						<Input :isDisabled="viewMode" :isRequired="true" ref="comm_40" placeholder="40'" style="margin: 0 0 0 5px;"
							:inputValue.sync="comm_40" :regex="commRegex" :errorMessage.sync="comm40Error" />
					</div>
					<Input :isDisabled="viewMode" ref="tariff_toll" placeholder="Toll" :inputValue.sync="tariff_toll" :regex="tollRegex" :errorMessage.sync="tollError" />
					<div class="rowBox">

						<DateTimePicker :isDisabled="viewMode" placeholder="Valid From" :value.sync="validFr" :isRequired="true" :errorMessage.sync="validFrError" ref="start_date"
						:showTime="false"  style="margin: 0 5px 0 0; width:50%;" />
						<DateTimePicker :isDisabled="viewMode" placeholder="Valid To" :value.sync="validTo"
						:showTime="false"	style="margin: 0 0 0 5px; width:50%;" />
					</div>
					<div class="DestinationCompanyTable">
						<TableBox :tableData="auditCompanyData" :hideColumns="['Area Code']" :maxSelection="0"
							title="Company and Destination Code" />
					</div>
				</div>

				<div class="gen-details-left" v-if="showStatusHistory" style="width : 45%; margin : 0 10px 0 20px;">
					<TableBox style="height: 100%" title="Area Status History" :tableData="statusHistoryData" />
					<button @click="showStatusHistory = false"
						style="margin: 10px 0; padding: 10px 30px; float: right;">OK</button>
				</div>
			</div>
		</PopupEntry>

	</div>
</template>

<script>
/* eslint-disable */
export default {
	components: {
	},
	data: function () {
		return {
			menu: [
				{ title: 'New Tariff Rate', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png', key: 'MnuNew', visible: true, enabled: true },
				{ title: 'Edit Tariff Rate', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-edit-64%20(1).png', key: 'MnuEdit', visible: true, enabled: true },
				{ title: 'Delete Tariff Rate', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png', key: 'MnuDelete', visible: false, enabled: true}, //api response logic abit weird ("Hide Delete" instead of "Delete")
				{ title: 'View Tariff Rate', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-view-64.png', key: 'MnuQuery', visible: true, enabled: true },
			],
			newAreaCode:'',

			//general data
			tariffRateList: [],
			areaCodeData: [],
			areaCodeNoTR:[],
			zoneCategoryData: [],
			zoneTypeData: [],
			statusHistoryData: [],
			selectedAreaCode: null,
			tariffArea: '',
			//tariffBase: '',
			tariffRegion: '',
			selectedZoneCategory: null,
			selectedZoneType: null,
			rate_20: '',
			rate_40: '',
			comm_20: '',
			comm_40: '',
			tariff_toll: '',
			validStatusData: [],
			validFr: null,
			validTo: null,
			showStatusHistory: false,

			//company and destination data
			auditCompanyData: [],
			destinationCode: '',
			companyName: '',

			selectedArea: [],
			popupEntryShow: false,
			createdBy: '',
			updatedBy: '',
			viewModePK:false,
			viewMode: false,
			tariffAreaViewMode: true,
			
			isActive: false,

			//error data
			tariffAreaError: '',
			tariffCodeError: '',
			baseError: '',
			tariffRegionError: '',
			zoneCategoryError: '',
			zoneTypeError: '',
			rate20Error:'',
			rate40Error:'',
			comm20Error:'',
			comm40Error:'',
			tollError: '',
			validFrError:'',

			rateRegex: {
				regex: /\d*\.?\d*/g,
				live: true,
				autoClear: false
			},
			commRegex: {
				regex: /\d*\.?\d*/g,
				live: true,
				autoClear: false
			},
			tollRegex: {
				regex: /\d*\.?\d*/g,
				live: true,
				autoClear: false	
			},

			entryRequired: [],
			entrySuccess: [],
			entryMessages: [],
			entryError: [],
			errorMapping: [
				{ key: 'tariff_code', tab: -1 },
        { key: 'tariff_area', tab: 0 },
        { key: 'tariff_base', tab: 0 },
        { key: 'tariff_region', tab: 0 },
        { key: 'zone_category', tab: 0 },
        { key: 'zone_type', tab: 0 },
        { key: 'rate_20', tab: 0 },
        { key: 'rate_40', tab: 0 },
        { key: 'comm_20', tab: 0 },
        { key: 'comm_40', tab: 0 },
        { key: 'tariff_toll', tab: 0 },
        { key: 'start_date', tab: 0 },
        // { key: 'end_date', tab: 0 },
			],

			columnTypeMain:{
					"#" : "number",
          "20' Rate" : "currency",
          "40' Rate" : "currency",
          "Toll Rate" : "currency",
          "Driver Rate" : "currency",   
					"Valid From" : "date",
					"Valid To" : "date",
					"Updated on" : "date"
			},
		}
	},
	props: {
	},
	//view tariff rate done
	methods: {
		entryRequiredClicked: function(item) {
      let errorTabs = this.errorMapping.find(e => e['key'] == item);
      
      if (this.currentTab != errorTabs['tab'] && errorTabs['tab'] >= 0) {
        this.currentTab = errorTabs['tab'];
      }

			this.$nextTick(() => {
				this.$refs[item].setFocus();
			});
    },
		menuClicked: async function (e) {
			this.clearEntryMessages();
			this.clearDestinationAudit();
			this.clearAllFields();
			switch (e.title) {
				case 'New Tariff Rate':
					this.validFr = new Date();
					this.popupEntryShow = true;
					this.getAreaCode();
					this.viewMode = false;
					this.viewModePK = false;
					this.tariffAreaViewMode = true;
					this.popupEntryTitle = 'New Tariff Rate';
					this.createdBy = '';
					this.updatedBy = '';
					break;
				case 'Edit Tariff Rate':
				//	this.actionflag = this.popupEntryTitle[0];
				if (this.selectedArea.length == 0) {
						this.$showAlert('error', 'No Area Selected', 'Please select an Area to edit tariff rate');
					} else {	
					this.viewMode = false;
					this.viewModePK = true;
					this.tariffAreaViewMode = false;
					this.popupEntryShow = true;
					this.popupEntryTitle = 'Edit Tariff Rate';
					await this.populateAreaDetails(this.selectedArea[0]['Area Code'], this.selectedArea[0]['Base']);
				}
					break;
				case 'Delete Tariff Rate':
					if (this.selectedArea.length == 0) {
						this.$showAlert('error', 'No Area Selected', 'Please select an Area to view tariff rate');
					} else {
						let deleting = await this.$showAlert('warning', 'Delete Tariff Rate', `Are you sure you want to delete tariff rate for ${this.selectedArea[0]['Area Name']}, base ${this.selectedArea[0]['Base']}?`, [
							{ text: 'Delete', textColor: 'white', color: 'red' },
							{ text: 'Cancel', textColor: 'black', color: 'lightgray' },
						]);
						if (deleting == 'Delete') {
							let result = await this.$apiCallV2('/TariffRate/SaveTariffRate', {actionflag: 'D',
								base: this.selectedArea[0]['Base'], areacode: this.selectedArea[0]['Area Code']});
							  console.log(result);
							if (result[0]['Results'] == 0) { // Delete successful
								this.$showAlert('success', 'Tariff Rate Deleted', `Successfully deleted tariff area for area ${this.selectedArea[0]['Area Name']}, base ${this.selectedArea[0]['Base']}`);
								this.$nextTick(async () => await this.getTariffRateList());
							} else { // Delete error
								this.$showAlert('error', 'Customer NOT Deleted', `There was an error deleting tariff area for area ${this.selectedArea[0]['Area Name']}, base ${this.selectedArea[0]['Base']}`);
							}
						}
					}
					break;
				case 'View Tariff Rate':
				this.clearEntryMessages();
				this.clearDestinationAudit();
					if (this.selectedArea.length == 0) {
						this.$showAlert('error', 'No Area Selected', 'Please select an Area to view tariff rate');
					} else {
						this.viewModePK = true;
						this.tariffAreaViewMode = true;
						this.viewMode = true;
						this.popupEntryShow = true;
						this.popupEntryTitle = 'View Tariff Rate';
						await this.populateAreaDetails(this.selectedArea[0]['Area Code'], this.selectedArea[0]['Base']);
					}
					break;
			}
		},
		saveClicked: async function () {
			
			let isNotValid = this.checkFields();
			console.log(this.entryRequired[0]);
			if ( !isNotValid ) {
				let action = this.popupEntryTitle[0];
				console.log(action);
				let dataToPost = {
					'base': this.tariffBase.toUpperCase(),
					'actionflag': action,
					'areacode': this.newAreaCode.toUpperCase(),
					'areaname': this.tariffArea,
					'region': this.tariffRegion,			
					'rate20': this.rate_20,
					'rate40': this.rate_40,
					'tollrate': this.tariff_toll,
					'startvaliddate': this.validFr ? this.$dateTime.getDateTime(this.validFr, 'yyyy-MM-dd') : '',
					'endvaliddate': this.validTo ? this.$dateTime.getDateTime(this.validTo, 'yyyy-MM-dd') : '',
					'driverrate20': this.comm_20,
					'driverrate40': this.comm_40,	
					'zonetype': this.selectedZoneType ? this.selectedZoneType['Zone Type'] : '',
					'zonecategory': this.selectedZoneCategory ? this.selectedZoneCategory['Zone Category'] : '',		
				};
				this.loadingText = dataToPost['Action'] == 'D' ? 'Deleting Tariff Rate' : 'Saving Tariff Rate';

					this.$fullscreenLoading('Saving Tariff Rate');
					let result = await this.$apiCallV2('/TariffRate/SaveTariffRate', dataToPost);
					this.$nextTick(async () => await this.getTariffRateList());
					console.log("result code: "+ result);
					this.$fullscreenLoading();

					if (result[0]['Results'] == 0) { // Save successful
						if (action == 'N') {
							this.entrySuccess.push(`Successfully created Tariff Rate for area: ${this.tariffArea}`);
						} else {
							this.entrySuccess.push(`Successfully edited Tariff Rate for area: ${this.tariffArea}`);
						}

					this.viewMode = true;
					
					} else { // Save error
						if (action == 'N') {
							this.entryError.push(`There was an error creating tariff rate: ${result[0]['ErrMsg']}`);
						} else {
							this.entryError.push(`There was an error editing tariff rate: ${result[0]['ErrMsg']}`);
						}
					}
				
			}
		},
		focusChanged: async function(state){
			if(!state){
        await this.$nextTick(); //wait for the next render complete so that certain variable can retrieve the value
				//check for tariff code with existing rate
				let areaExists1 = false;

				//tariff rate exists
				this.tariffRateList.forEach(c => {
					if(c['Area Code'] == this.newAreaCode.toUpperCase() && c['Base'] == this.tariffBase){
						areaExists1 = true;
					}
				});
				if(areaExists1 == true){
					this.$showAlert('error', 'Tariff Rate Already Exists', 'Please go to "Edit Tariff Rate" to make changes');
				}

				//check for completely new tariff code
				let areaExists = false;
				this.areaCodeData.forEach(c => {
          if( c['Area Code'] == this.newAreaCode.toUpperCase() || this.newAreaCode == '' ){
            areaExists = true;
						}
					});					
					if(areaExists == false){
						let alert = await this.$showAlert('Warning', 'Tariff Area Code does not exist.', 'Add new Tariff Area Code?', [
  		  		{ text: 'Confirm', color: 'green', textColor: 'white' },
    				{ text: 'Cancel', color: 'red', textColor: 'white' },
  					]);
						if(alert == 'Cancel'){
							this.clearAllFields();
							this.tariffAreaViewMode = true;
						}else{
							this.tariffAreaViewMode = false;
						}
					}
			}
		},
		getTariffRateList: async function(){
					this.tariffRateList = [];
					this.$fullscreenLoading('Getting Tariff Rates');
				 	this.tariffRateList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'TARIFFAREARATE' });
					this.$fullscreenLoading();
		},
		populateAreaDetails: async function (area, base_t) {
			this.loading = true;
			this.loadText = 'Getting Details';
			let details = (await this.$apiCallV2(`/TariffRate/GetDetailsMaster?masterfile=tariffrate&recordid=${area}&baseTariff=${base_t}`))['TariffRate'];
			this.isActive = details['Status'] == 'A';
			//region to populate popupentry
			this.selectedAreaCode = this.populateObject(this.areaCodeData, 'Area Code', details['CHAMAreaCode']);
			this.newAreaCode = this.selectedAreaCode;
			this.tariffArea = this.populateTextTrim(details['CHAMArea']);
			this.tariffBase = this.populateTextTrim(details['Base']);
			this.tariffRegion = this.populateTextTrim(details['CHAMRegion']);
			this.selectedZoneCategory = this.populateObject(this.zoneCategoryData, 'Zone Category', details['ZoneCategory']);
			this.selectedZoneType = this.populateObject(this.zoneTypeData, 'Zone Type', details['ZoneType']);
			this.rate_20 = this.populateTextTrim(details['CHAMRate20']);
			this.rate_40 = this.populateTextTrim(details['CHAMRate40']);
			this.comm_20 = this.populateTextTrim(details['DriverRate']);
			this.comm_40 = this.populateTextTrim(details['DriverRate']);
			this.tariff_toll = this.populateTextTrim(details['CHAMTollRate']);
			this.validFr = details['StartValidDate'] ? new Date(details['StartValidDate']) : null;
			this.validTo = details['EndValidDate'] ? new Date(details['EndValidDate']) : null;
			console.log(this.validFr);
			
			//POPULATING AUDIT PART
			this.auditCompanyData = details['Destination'] ? Array.isArray(details['Destination']) ? details['Destination'] : [details['Destination']] : [];

			//created by updated by
			this.createdBy = `${details['UserCreated'] ? details['UserCreated'] : ''} ${details['DateCreated'] ? this.$dateTime.getDateTime(new Date(details['DateCreated']), 'dd/MM/yyyy HH:mm') : ''}`;
			this.updatedBy = `${details['UserID'].trim() ? details['UserID'].trim() : ''} ${details['DateUpdated'] ? this.$dateTime.getDateTime(new Date(details['DateUpdated']), 'dd/MM/yyyy HH:mm') : ''}`;
		},
		clearEntryMessages: function () {
			this.entryRequired = [];
			this.entrySuccess = [];
			this.entryMessages = [];
			this.entryError = [];
		},
		clearAllFields: function () {
			this.selectedAreaCode = null;
			this.newAreaCode = '';
			this.tariffArea = '';
			//this.tariffBase = '';
			this.tariffRegion = '';
			this.selectedZoneCategory = null;
			this.selectedZoneType = null;
			this.rate_20 = '';
			this.rate_40 = '';
			this.comm_20 = '';
			this.comm_40 = '';
			this.tariff_toll = '';
			this.validFr = null;
			this.validTo = null;

			this.tariffCodeError = '';
			this.tariffAreaError = '';
			this.baseError = '';
			this.tariffRegionError = '';
			this.zoneCategoryError = '';
			this.zoneTypeError = '';
			this.rate20Error = '';
			this.rate40Error = '';
			this.comm20Error = '';
			this.comm40Error = '';
			this.tollError = ''
			this.validFrError = '';
		},
		clearDestinationAudit: function () {
			this.auditCompanyData = [];
		},
		checkFields: function () {
			this.clearEntryMessages();
			if (!this.selectedAreaCode && !this.newAreaCode) {
				this.tariffCodeError = 'Tariff Area Code is required!';
				this.entryRequired.push({ key: 'tariff_code', value: 'Tariff Area Code is required!' });
			}
			else if (this.newAreaCode) {
				if (this.newAreaCode.length > 10) {
					this.tariffCodeError = 'Tariff Area Code cannot exceed 10 characters!'
					this.entryRequired.push({ key: 'tariff_code', value: 'Tariff Area Code cannot exceed 10 characters!' });
				}
			}
			if (!this.tariffArea) {
				this.tariffAreaError = 'Tariff Area is required!';
				this.entryRequired.push({ key: 'tariff_area', value: 'Tariff Area is required!' });
			}
			else {
				if (this.tariffArea.length > 60) {
					this.tariffAreaError = 'Tariff Area cannot exceed 60 characters!'
					this.entryRequired.push({ key: 'tariff_area', value: 'Tariff Area cannot exceed 60 characters!' })
				}
			}
			if (!this.tariffBase) {
				this.baseError = 'Base is required!';
				this.entryRequired.push({ key: 'tariff_base', value: 'Base is required!' });
			}
			if (this.tariffRegion.length > 40) {
				this.tariffRegionError = "Tariff Region cannot exceed 40 characters!"
				this.entryRequired.push({ key: 'tariff_region', value: 'Tariff Region cannot exceed 40 characters!' });
			}
			if (!this.selectedZoneCategory) {
				this.zoneCategoryError = 'Zone Category is required!';
				this.entryRequired.push({ key: 'zone_category', value: 'Zone Category is required!' });
			}
			if (!this.selectedZoneType) {
				this.zoneTypeError = 'Zone Type is required!';
				this.entryRequired.push({ key: 'zone_type', value: 'Zone Type is required!' });
			}
			if (!this.rate_20) {
				this.rate20Error = 'Rate for container size 20 is required!';
				this.entryRequired.push({ key: 'rate_20', value: 'Rate for container size 20 is required!' });
			}
			else {
				if (!this.rate_20.match(/^\d*\.?\d*$/g)) {
        	this.rate20Error = 'Rate for container size 20 format error!';
        	this.entryRequired.push({ key: 'rate_20', value: 'Rate for container size 20 format error! Please make sure input is in money format.' });
				}
				else if (+this.rate_20 > 900000000000000) {
        	this.rate20Error = 'Rate for container size 20 value too big!';
        	this.entryRequired.push({ key: 'rate_20', value: 'Rate for container size 20 value too big!' });
				}
			}
			if (!this.rate_40) {
				this.rate40Error = 'Rate for container size 40 is required!';
				this.entryRequired.push({ key: 'rate_40', value: 'Rate for container size 40 is required!' });
			}
			else {
				if (!this.rate_40.match(/^\d*\.?\d*$/g)) {
        	this.rate40Error = 'Rate for container size 40 format error!';
        	this.entryRequired.push({ key: 'rate_40', value: 'Rate for container size 40 format error! Please make sure input is in money format.' });
				}
				else if (+this.rate_40 > 900000000000000) {
        	this.rate40Error = 'Rate for container size 40 value too big!';
        	this.entryRequired.push({ key: 'rate_40', value: 'Rate for container size 40 value too big!' });
				}
			}
			if (!this.comm_20) {
				this.comm20Error = 'Driver commission for container size 20 is required!';
				this.entryRequired.push({ key: 'comm_20', value: 'Driver commission for container size 20 is required!' });
			}
			else {
				if (!this.comm_20.match(/^\d*\.?\d*$/g)) {
        	this.comm20Error = 'Driver commission for container size 20 format error!';
        	this.entryRequired.push({ key: 'comm_20', value: 'Driver commission for container size 20 format error! Please make sure input is in money format.' });
				}
				else if (+this.comm_20 > 900000000000000) {
        	this.comm20Error = 'Driver commission for container size 20 value too big!';
        	this.entryRequired.push({ key: 'comm_20', value: 'Driver commission for container size 20 value too big!' });
				}
			}
			if (!this.comm_40) {
				this.comm40Error = 'Driver commission for container size 40 is required!';
				this.entryRequired.push({ key: 'comm_40', value: 'Driver commission for container size 40 is required!' });
			}
			else {
				if (!this.comm_40.match(/^\d*\.?\d*$/g)) {
        	this.comm40Error = 'Driver commission for container size 40 format error!';
        	this.entryRequired.push({ key: 'comm_40', value: 'Driver commission for container size 40 format error! Please make sure input is in money format.' });
				}
				else if (+this.comm_40 > 900000000000000) {
        	this.comm40Error = 'Driver commission for container size 40 value too big!';
        	this.entryRequired.push({ key: 'comm_40', value: 'Driver commission for container size 40 value too big!' });
				}
			}
			if (!this.tariff_toll.match(/^\d*\.?\d*$/g) && this.tariff_toll) {
				this.tollError = 'Toll format error!';
				this.entryRequired.push({ key: 'tariff_toll', value: 'Toll format error! Please make sure input is in money format.' });
			}
			else {
				if (+this.tariff_toll > 900000000000000) {
        	this.tollError = 'Toll value too big!';
        	this.entryRequired.push({ key: 'tariff_toll', value: 'Toll value too big!' });
				}
			}
			if (!this.validFr) {
				this.validFrError = 'Validity start date is required!';
				this.entryRequired.push({ key: 'start_date', value: 'Validity start date is required!' });
			}
			return this.entryRequired.length > 0;
		},
		populateObject: function (data, key, compare) { // To populate object into dropdown or input query
			try {
				return data.find(d => d[key].trim() == (compare ? compare.trim() : ''));
			} catch (error) {
				return null;
			}
		},
		populateTextTrim: function (text) { // To populate text with trim
			return text ? text.trim() : '';
		},
		getAreaCode: async function() {
			this.$fullscreenLoading('Getting Area Codes');
			this.areaCodeNoTR = [];
			this.areaCodeNoTR = await this.$apiCallV2(`/Master/GetListMaster`, { masterfile: 'area', action: 'N' });
			this.areaCodeData = await this.$apiCallV2(`/Master/GetListMaster`, { masterfile: 'area', action: 'E' });
			this.$fullscreenLoading();
		}
	},
	async mounted() {
		this.$bus.$on('pageSASControlAccess', (x) => {
			
			if (x.page == 'Tariff Rate') {
				x.data.forEach(k => {
					console.log(k);
					//key in menu same as control value from api
					let selectedMenu = this.menu.find(m => m['key'] == k['Control']);		
					if (selectedMenu) {
						selectedMenu[k['Properties'].toLowerCase()] = (k['PropertiesValue'] == 'True');
					}
				})
			}
		})

		this.getAreaCode();

		this.$fullscreenLoading('Getting Zone Category');
		this.zoneCategoryData = await this.$apiCallV2('/Master/GetListMaster', {masterfile: 'ZONECATEGORY'});

		this.$fullscreenLoading('Getting Zone Types');
		this.zoneTypeData = await this.$apiCallV2('/Master/GetListMaster', {masterfile: 'zone'});

		this.$fullscreenLoading('Getting Tariff Rates');
		this.tariffRateList = await this.$apiCallV2('/Master/GetListMaster', {masterfile: 'TARIFFAREARATE'});

		//getting current base value
		var loginDetails = await this.$apiCallV2('/Login/GetDetails');
		this.tariffBase = loginDetails['BaseName'];

	
		this.$fullscreenLoading();
	},

	watch: {
	},
}

</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.tariff-rate-main {
	font-size: 12px;
	width: 100%;
	height: 100%;
	padding: 10px 45px;
	display: flex;

	.tariffRateTable {
		width: 100%;
		margin-left: 5px;
		padding: 5px;
		background-color: white;
		border-radius: 5px;
		display: flex;
		overflow: hidden;
	}

}

.tariff-area-code {
	display: flex;

	> :last-child {
		margin-left: 5px;
	}
}

.gen-details-right{
	display: flex;
	flex-direction: column;
	width: 100%;
	.DestinationCompanyTable {
		margin-left: 5px;
		padding: 5px;
		width: 100%;
		background-color: white;
		border-radius: 5px;
		overflow: hidden;
	}
}

.rowBox {
	display: flex;
}
</style>
